import { Navigate } from 'react-router-dom';
import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  WAIBI_ACCESS_TOKEN,
  WAIBI_REFRESH_TOKEN,
} from 'shared/config';
import { ROUTES } from 'const';
import { removeFromStorage } from 'helpers/storage';
import { ADDITIONAL_USERS_LOCAL_STORAGE_KEYS } from 'const/additionalUsers';

const { DATASET_KEY, DELETED_USERS_KEY } = ADDITIONAL_USERS_LOCAL_STORAGE_KEYS;

export const LogoutHandler = () => {
  removeFromStorage({
    key: [
      WAIBI_ACCESS_TOKEN,
      WAIBI_REFRESH_TOKEN,
      DATASET_KEY,
      DELETED_USERS_KEY,
    ],
  });
  removeFromStorage({
    key: [ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY],
    storage: sessionStorage,
  });

  return <Navigate to={ROUTES.ROOT} replace />;
};
